import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";

type ClassicRegisterContent =
  | "register"
  | "register-member-to-verify"
  | "register-member-to-verify-confirmation"
  | "register-member-not-found"
  | "register-member-already-verified"
  | "register-no-email"
  | "register-error";
type VCESRegisterContent = "vces" | "vces-validator" | "vces-member-datafeed" | "vces-member-vces";
type RegisterContent = ClassicRegisterContent | VCESRegisterContent;

interface Member {
  memberId: string;
  eligibility_criteria?: Record<string, unknown>;
}

interface RegisterState {
  registerContent: RegisterContent | null;
  memberToRegister: Member | null;
  correlationId: string | null;
  isLoading: boolean;
  error: string | null;
}

interface RegisterActions {
  setRegisterContent: (registerContent: RegisterContent) => void;
  setMemberToRegister: (member: Member | null) => void;
  setCorrelationId: (correlationId: string | null) => void;
  setIsLoading: (isLoading: boolean) => void;
  resetRegister: () => void;
  setRegisterError: (error: string | null) => void;
}

export const initialState: RegisterState = {
  registerContent: null,
  memberToRegister: null,
  correlationId: null,
  isLoading: false,
  error: null,
};

export const useRegisterStore = createWithEqualityFn<RegisterState & RegisterActions>()(
  (set) => ({
    ...initialState,
    setRegisterContent: (registerContent: RegisterContent) => set({ registerContent }),
    setMemberToRegister: (member: Member | null) => set({ memberToRegister: member }),
    setCorrelationId: (correlationId: string | null) => set({ correlationId }),
    setIsLoading: (isLoading: boolean) => set({ isLoading }),
    resetRegister: () => set(initialState),
    setRegisterError: (error: string | null) => set({ error }),
  }),
  shallow,
);
